import { axiosRequest } from '../../utils/commonFn';
import {loadmyorderinfoUrl,loadaddressinfoUrl,loadmygamegiftUrl,receivegamegiftUrl,editorderaddressUrl,loadorderlogisticlistUrl,cancelorderUrl,loadexchangerewardlistUrl,exchangegamegiftUrl,loadmyexchangelistUrl, getcardlist,blackPageUrl} from '../../consts';

// 我的订单
export const loadmyorderinfo = async(params) =>{
     const { data } = await axiosRequest(loadmyorderinfoUrl, 'get', params, {})
     return data
}

export const loadaddressinfo = async(params) =>{
    const { data } = await axiosRequest(loadaddressinfoUrl, 'get', params, {})
    return data
}
// 领取游戏内道具
export const loadmygamegiftDatas = async(params) =>{
    const { data } = await axiosRequest(loadmygamegiftUrl, 'get', params, {})
    return data
}
// 领取游戏礼包
export const receivegamegiftDatas=async (params) => {
    const { data } = await axiosRequest(receivegamegiftUrl, 'post', { ...params }, {})
    return data
}

// 我的订单修改地址
export const editorderaddress = async(params) =>{
     const { data } = await axiosRequest(editorderaddressUrl, 'post', params, {})
     return data
}

// 我的物流详情
export const loadorderlist = async (params) =>{
    const { data } = await axiosRequest(loadorderlogisticlistUrl, 'get', params, {})
    return data;
}

//取消订单
export const cancelorder = async (params) =>{
    const { data } = await axiosRequest(cancelorderUrl, 'post', params, {})
    return data;

}
// 加载兑换奖励下拉列表接口
export const loadexchangerewardlist=async (params) =>{
    const { data } = await axiosRequest(loadexchangerewardlistUrl, 'get', params, {})
    return data;

}
// 兑换游戏礼包接口
export const exchangegamegiftDatas= async (params) =>{
    const { data } = await axiosRequest(exchangegamegiftUrl, 'post', params, {})
    return data;

}
// 加载我的兑换记录列表接口
export const loadmyexchangelistDatas=async (params) =>{
    const { data } = await axiosRequest(loadmyexchangelistUrl, 'get', params, {})
    return data;

}
// 兑换卡查询
export const getCardLists=async (params) =>{
    const { data } = await axiosRequest(getcardlist, 'get', params, {})
    return data;

}
// 黑白页控制
export const blackPage = async () =>{
    const { data } = await axiosRequest(blackPageUrl, 'get', {}, {})
    return data;

}